import styled from 'styled-components';
import { Button, Form, Input, InputNumber, Col } from 'antd';

const RED_COLOR = '#ff4d4f';
const BLUE_COLOR = '#2f54eb';
const GRAY_COLOR = '#e6e6e6';
const BLACK_COLOR = '#0000000b';

export const StepsContainer = styled(Col)`
	max-width: 60vw;
	border-radius: 1rem;
	background-color: #f8f8f8;
	padding: 2rem 3rem !important;

	@media (max-width: 1600px) {
		max-width: 72vw;
	}

	@media (max-width: 1200px) {
		max-width: 85vw;
	}

	@media (max-width: 576px) {
		padding: 1.5rem !important;
	}
`;

export const LogoWrapper = styled.div`
	width: 100%;
	margin-top: 19px;
	height: 0;
	display: flex;
	justify-content: center;
	margin-bottom: 0px;
`;

export const LogoImage = styled.img`
	height: 50px;
	display: block;
`;

export const Title = styled.h1`
	color: ${BLUE_COLOR};
	text-align: center;
	margin-bottom: 10px;
	margin-top: 25px;
	font-size: 1.8rem;
	font-weight: bold;

	@media (max-width: 576px) {
		font-size: 1.5rem;
		margin-top: 32px;
	}
`;

export const RequiredFormItem = styled(Form.Item)`
	margin: 0;

	.ant-form-item-label {
		display: flex;
		justify-content: flex-start;
	}

	label {
		font-size: 1.1rem;
	}

	.custom-label-span {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.ant-form-item-extra {
		padding-top: 1.5rem;
	}

	.ant-form-item-required {
		display: flex;
		justify-content: flex-start;
		flex-direction: row-reverse;
		font-weight: 600;
		font-size: 1.1rem;
	}

	.ant-form-item-required::before {
		margin-left: 0.4rem;
		color: ${RED_COLOR} !important;
	}

	.ant-form-item-explain-error {
		position: absolute;
	}

	@media (max-width: 1240px) {
		.ant-form-item-label > label {
			font-size: 1rem !important;
			line-height: 0.9rem !important;
		}
		.custom-label-span {
			font-size: 1rem !important;
			line-height: 0.9rem !important;
		}
	}
`;

export const CustomInput = styled(Input)`
	font-size: 1rem;
	height: 2.5rem;
	line-height: 2.5rem;
	padding-top: 0;
	padding-bottom: 0;
	border-radius: 6px;
	border: 2px solid ${GRAY_COLOR} !important;
	box-sizing: border-box;

	@media (max-width: 1024px) {
		font-size: 0.9rem;
	}
`;

export const CustomInputNumber = styled(InputNumber)`
	font-size: 1rem;
	height: 2.5rem;
	width: 100%;
	padding-bottom: 0;
	padding-top: 3px;
	border-radius: 6px;
	border: 2px solid ${GRAY_COLOR} !important;

	@media (max-width: 992px) {
		font-size: 0.9rem;
	}
`;

export const CurrencyInput = styled.div`
	display: flex;
	align-items: center;
	border: 1px solid #ccc;
	border-radius: 8px;

	span {
		padding: 10px;
		background-color: #f0f0f0;
		border-right: 1px solid #ccc;
		color: #4c4c4e;
		opacity: 0.7;
		border-top-left-radius: 8px;
		border-bottom-left-radius: 8px;
	}

	input {
		border: none !important;
		border-radius: 0 8px 8px 0 !important;
		box-shadow: none !important;
		outline: none !important;
		padding-left: 8px !important;
		width: 100% !important;
	}
`;

export const PreviousButton = styled(Button)`
	display: flex;
	font-size: 1rem;
	border-radius: 7px;
	align-items: center;
	padding: 1.15rem 1rem;
	justify-content: center;
	box-shadow: 0px 2px 0px 0px ${BLACK_COLOR};
`;

export const NextButton = styled(Button)`
	display: flex;
	font-size: 1rem;
	border-radius: 7px;
	align-items: center;
	justify-content: center;
	padding: 1.15rem 1.5rem;
	background-color: ${BLUE_COLOR};
	color: white;
	box-shadow: 0px 2px 0px 0px ${BLACK_COLOR};
`;
